import React from 'react';

const Unauthorized = () => {
  return <h1>You are not authorized</h1>;
};

export { Unauthorized };
